import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4 py-24 text-center relative overflow-hidden">
      <div className="absolute inset-0 net-grid opacity-50" />
      <div className="relative z-10 max-w-lg">
        <span className="font-heading text-7xl md:text-9xl font-black text-background-300 select-none">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这个页面并不存在
        </h1>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
          你访问的地址可能已经调整，或者链接出现了笔误。
          <span className="block mt-1 font-label text-foreground-500">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label whitespace-nowrap transition-colors"
          >
            返回首页
          </Link>
          <Link
            to="/events"
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-900 text-sm font-label whitespace-nowrap transition-colors"
          >
            浏览事件追踪库
          </Link>
        </div>
      </div>
    </div>
  );
}